/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import useUserSubscription from "../../hooks/useUserSubscription";
import SEO from "../SEO";
import useCreateZohoSubscription from "../../hooks/useCreateZohoSubscription";
import Usersidesetting from "../usersidesetting";
import "./subscription.scss"
// import Usersidesetting from "../(component)/usersidesetting";

const Subscription = () => {
  debugger
  const { subscriptionData } = useUserSubscription();
  useCreateZohoSubscription();
  console.log(subscriptionData, "subscriptionData");


  const onButtonClick = (url, name) => {
    fetch(url).then((response) => {
      response.blob().then((blob) => {

        // Creating new object of PDF file
        const fileURL =
          window.URL.createObjectURL(blob);

        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = `${name}.pdf`;
        alink.click();
      });
    });
  };


  return (
    <>
      <SEO
        title={"Subscription" || ''}
        description={''}
        url={''}
        ogTag={''}
        metaKeywords={''}
      />
      <div className="container usersetting">
        <Usersidesetting />
        <div className="usersetting_right">
          <div className="usersetting_right_title">
            <h3> Subscriptions </h3>
            <a href='/plans' className="normal_blue_btn"> Purchase Plan </a>
          </div>
          <div className="zoho-checkout-org-table-container">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Plan Name</th>
                  <th>No of License</th>
                  <th>Plan Validity</th>
                  <th>Amount</th>
                  <th>Last Billed On</th>
                  <th>Next Billed On</th>
                  <th>Invoice</th>
                  {/* <th></th> */}
                </tr>
              </thead>
              <tbody>
                {subscriptionData.length ?
                  subscriptionData?.map((item) => (
                    <tr key={item?.subscriptionId}>
                      <td>{item?.planName}</td>
                      <td>{item?.noOfLicense}</td>
                      <td>{item?.validity}</td>
                      <td>
                        {item?.currencySymbol}
                        {item?.amount}
                      </td>
                      <td>{item?.transcationDate}</td>
                      <td>{item?.nextBilling}</td>
                      <td>
                        <a onClick={() => onButtonClick(`https://dev-user-access.kronicle.in/zoho/invoice/${item.invoiceId}`, item?.invoiceNumber)}
                          style={{ fontSize: '14px', fontWeight: 500, color: '#216DDE', textDecoration: 'none', cursor: 'pointer' }}
                        >
                          Invoice
                        </a>
                      </td>
                      {/* <td>
              <input
                type="checkbox"
                onChange={(e) =>
                  handleCheckboxChange(item?.subscriptionId, e.target.checked)
                }
                className="zoho-custom-checkbox"
              />
            </td> */}
                    </tr>
                  ))
                  :
                  <tr>
                    <td colspan={7} style={{ textAlign: 'center' }}> No Subscription Purchased</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div >
    </>
  );
};

export default Subscription;
